import { sendRequest } from "../clients/axios";

export type ExportDeliveryFilters = {
  deliveryCountries?: string | null;
  deliveryType?: string | null;
  organizationSlug?: string | null;
  carDeliveryDeadlineFrom?: Date | null;
  carDeliveryDeadlineTo?: Date | null;
  deliveryServices?: string | null;
};

export async function exportDeliveriesPartners(filters: ExportDeliveryFilters) {
  return sendRequest<ExportDeliveryFilters, Blob>(
    "post",
    "/delivery/export-deliveries-excel",
    filters,
    {
      responseType: "blob" as const,
    }
  );
}

export async function exportDeliveriesAdmins(filters: ExportDeliveryFilters) {
  return sendRequest<ExportDeliveryFilters, Blob>(
    "post",
    "/delivery/export-deliveries-excel-admins",
    filters,
    {
      responseType: "blob" as const,
    }
  );
}
